import { render } from "./LegalWarningView.vue?vue&type=template&id=d40ced3e"
import script from "./LegalWarningView.vue?vue&type=script&lang=js"
export * from "./LegalWarningView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__